module.exports = __webpack_public_path__ + "static/media/bjs.50e72528.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/bjs.jpg
// module id = 1314
// module chunks = 0